import { Modal } from "../../modal/modal";
import { useEffect, useState } from "react";
import "./steps.css";
import {
  getSessionMetadata,
  getSessionResume,
} from "../../../redux/actions/fluxoNSimilar";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import {
  resetSession,
  resetSessionStatus,
} from "../../../redux/slices/sessionSlice";
import {
  resetClear,
  resetMessage,
} from "../../../redux/slices/sessionMenssageSlice";
import { Skeleton } from "@mui/material";
import ErrorComponent from "../../errorRetry/errorRetry";
import { useNavigate } from "react-router-dom";
import { useRoles } from "../../../hooks/roles";

interface ClassificationResultProps {
  onConfirm: () => void;
  getSessionId: any;
  setQuestionsTrue: any;
  setGetNcm: any;
  setDisplayTableAtributes: any;
  onFinalizeClassification: () => void;
}

const ClassificationResult = ({
  onConfirm,
  getSessionId,
  setQuestionsTrue,
  setGetNcm,
  setDisplayTableAtributes,
  onFinalizeClassification,
}: ClassificationResultProps) => {
  const [loading, setLoading] = useState(true);
  const [getNumberNcm, setGetNumberNcm] = useState("");
  const [retryCount, setRetryCount] = useState(0);
  
  const maxRetries = 4;
  const dispatch = useDispatch<AppDispatch>();
  const modalState = true;

  const navigate = useNavigate();

  const { isTax } = useRoles();
  const backButtonFinalizar = () => {
    dispatch(resetSessionStatus());
    dispatch(resetSession());
    dispatch(resetClear());
    navigate(isTax ? "/home-tax" : "/home-engenheiro");
    setQuestionsTrue(false);
    setDisplayTableAtributes(false);
    onFinalizeClassification();
  };

  const handleModalFinalizeClose = () => {
    navigate(
      `/detalhes-material/${getNumberNcm}?center=${
        localStorage.getItem("selectedCenterForm")
          ? localStorage.getItem("selectedCenterForm")
          : localStorage.getItem("selectedCenter")
      }`,
    );
    dispatch(resetSessionStatus());
    dispatch(resetSession());
    dispatch(resetClear());
  };

  const { sessionMetadata, status } = useSelector(
    (state: RootState) => state.sessionMetadata,
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await dispatch(getSessionMetadata(getSessionId));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    if (retryCount <= maxRetries) {
      fetchData();
    }
  }, [getSessionId, retryCount]);

  const backButtonRefazerError = async () => {
    try {
      await dispatch(getSessionResume(getSessionId));
      dispatch(resetMessage());
      setDisplayTableAtributes(false);
      setQuestionsTrue(false);
    } catch (error) {
      console.error("Erro ao reiniciar a sessão:", error);
    }
  };

  useEffect(() => {
    if (status === "ready" && sessionMetadata != null) {
      setLoading(false);
    } else if (
      (status === "error" || sessionMetadata == null) &&
      retryCount < maxRetries
    ) {
      const retryTimeout = setTimeout(() => {
        setRetryCount((prev) => prev + 1);
      }, 30000);

      return () => clearTimeout(retryTimeout);
    } else if (retryCount >= maxRetries) {
      setLoading(false);
    }
  }, [status, sessionMetadata, retryCount, maxRetries]);

  useEffect(() => {
    if (sessionMetadata?.message?.outputFile) {
      const { product, ncmCode } = sessionMetadata.message.outputFile;
      setGetNcm({
        ncm: ncmCode,
        pn: product,
      });
      setGetNumberNcm(product);
    }
  }, [sessionMetadata]);

  const { sessionMessage } = useSelector( (state: RootState) => state.sessionMessage, ); 
  const finalized = sessionMessage?.message?.finalized === true;
  const finalizedStatus = sessionMessage?.message?.finalizedStatus; 
  
  const isSuccess = finalizedStatus === "success"; 
  const isError = finalizedStatus === "error"; 
  
  const shouldShowFinalizedModal =
    finalized && (isSuccess || isError);

  let finalizedModalTitle = "Classificação efetuada com sucesso!"; 
  if (isError) { 
    finalizedModalTitle = "Classificação finalizada como inconclusiva e ficará em auditoria de TXR."; 
  }


  return (
    <div style={{ paddingLeft: "35px" }}>
      {loading && (
        <div style={{ marginTop: 20, display: "none" }}>
          {Array.from({ length: 4 }, (_, i) => i + 1).map((id) => (
            <div key={id} style={{ marginBottom: 10 }}>
              <Skeleton variant="rectangular" width={580} height={80} />
            </div>
          ))}
        </div>
      )}

      {modalState && (
        <>
          {(loading || !shouldShowFinalizedModal) && (
            <div style={{ marginTop: 20 }}>
              {Array.from({ length: 4 }, (_, i) => i + 1).map((id) => (
                <div key={id} style={{ marginBottom: 10 }}>
                  <Skeleton variant="rectangular" width={580} height={80} />
                </div>
              ))}
            </div>
          )}

          {shouldShowFinalizedModal && retryCount <= 3 && (
            <Modal
              className="topGreen"
              classNameTwo="widthGreen"
              classNameAux="buttonAux"
              titleModal="Aviso"
              titleDescription={finalizedModalTitle}
              bodyModal="Você deseja verificar os detalhes da classificação?"
              buttonThree="Detalhes"
              buttonFour="Sair para Home"
              onConfirm={() => backButtonFinalizar()}
              onClose={() => handleModalFinalizeClose()}
            />
          )}
        </>
      )}

      {retryCount >= 3 && (
        <ErrorComponent onClick={() => backButtonRefazerError()} />
      )}
    </div>
  );
};

export default ClassificationResult;
